import React from 'react';
import NavBar from '../components/NavBar';


export default function Templates() {
  return (
    <div>
      <NavBar />
      <h1>Templates</h1>
    </div>
  );
}
